export default __webpack_public_path__ + "static/media/Image_1.f5165470.jpg";